import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { CONTACT } from '../../data/navigation';
interface HeroContactPanelProps {
  /** Distinguishes the desktop and stacked instances for label ids. */
  idSuffix: string;
  className?: string;
}
export function HeroContactPanel({
  idSuffix,
  className = ''
}: HeroContactPanelProps) {
  const headingId = `hero-help-heading-${idSuffix}`;
  return <aside aria-labelledby={headingId} className={`w-full border border-white/12 border-t-2 border-t-copper bg-navy/95 p-6 sm:p-7 ${className}`} data-id="element-152" data-mp="1wzj69z6xlhnb">
      <p className="flex items-center gap-3 font-mono text-[9.5px] tracking-label text-copper" data-id="element-153" data-mp="26xqi63md59ig">
        <span aria-hidden="true" className="h-px w-5 bg-copper" data-id="element-154" data-mp="21y45pweczxap" />
        APPLICATION HELP
      </p>
      <h2 id={headingId} className="mt-3 font-display text-[19px] font-medium leading-snug text-white" data-id="element-155" data-mp="3ibubr8p1gvmz">
        Talk through your setup
      </h2>

      <address className="mt-6 block not-italic" data-id="element-156" data-mp="qj3pnfm2p88h">
        <dl className="grid gap-x-6 gap-y-4 border-t border-white/10 pt-4 sm:grid-cols-2 lg:grid-cols-1" data-id="element-157" data-mp="qibw0ac1dkku">
          <div data-id="element-158" data-mp="vgn3ieeuzizw">
            <dt className="font-mono text-[9.5px] tracking-label text-aluminum/70" data-id="element-159" data-mp="vkaw9bchc1dk">
              CALL
            </dt>
            <dd className="mt-1.5" data-id="element-160" data-mp="14iwaiuax4u8j">
              <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-location="hero-panel" className="inline-flex min-h-[28px] items-center font-mono text-[15px] text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta" data-id="element-161" data-mp="14hv2kyp78nv1">
                800-397-7745
              </a>
            </dd>
          </div>
          <div className="min-w-0" data-id="element-162" data-mp="3l7s1gdy6j18c">
            <dt className="font-mono text-[9.5px] tracking-label text-aluminum/70" data-id="element-163" data-mp="3l6qqe9h5yeqm">
              EMAIL
            </dt>
            <dd className="mt-1.5" data-id="element-164" data-mp="3p7aobf9k9mdt">
              <a href={CONTACT.emailHref} data-analytics="email-click" data-analytics-location="hero-panel" className="inline-flex min-h-[28px] max-w-full items-center whitespace-nowrap text-[14.5px] text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta" data-id="element-165" data-mp="wedg066mvokh">
                sales@sheargeometry.com
              </a>
            </dd>
          </div>
          <div className="sm:col-span-2 lg:col-span-1" data-id="element-166" data-mp="8gxxwowmfobn">
            <dt className="font-mono text-[9.5px] tracking-label text-aluminum/70" data-id="element-167" data-mp="8iitmhuo9db3">
              MAILING ADDRESS
            </dt>
            <dd className="mt-1.5 max-w-[30ch] text-[13.5px] leading-relaxed text-aluminum" data-id="element-168" data-mp="ievkz92qvf2o">
              {CONTACT.mailingAddress}
            </dd>
          </div>
        </dl>
      </address>

      <Link to="/#product-guidance" data-analytics="product-guidance-cta" data-analytics-location="hero-panel" className="mt-6 inline-flex min-h-[44px] items-center gap-2 border-b border-copper text-[14px] font-semibold text-white transition-colors duration-150 ease-precise hover:text-cta" data-id="element-169" data-mp="1xxgz4fjltij1">
        Tell Us What You’re Cutting
        <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-170" data-mp="1rgx97p2ipsoi" />
      </Link>
    </aside>;
}